import { useTranslation } from "@flare/i18n";

import {
  getDate,
  getLocaleTimeWithAMPM,
} from "@/services/locale/date-time-formatting";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { PrivacyDisclaimer } from "../components/privacy-disclaimer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepSubtitle } from "../components/step-subtitle";
import { StepTitle } from "../components/step-title";

import { ContactInfoInputs } from "./components/contact-info-inputs";
import type { StepProps } from "./step.types";

export default function ContactInfoReschedule({ answers }: StepProps) {
  const { t } = useTranslation();
  const { eventStartTime } = answers;
  const date = eventStartTime && new Date(eventStartTime);
  const contentSubtitle = date
    ? t("FUNNEL_CONTACT_INFO_SUBTITLE_WITH_DATE", {
        dateText: getDate({
          date,
          monthFormat: "short",
          hideYear: true,
        }),
        timeText: getLocaleTimeWithAMPM(date),
      })
    : t("FUNNEL_CONTACT_INFO_SUBTITLE_DEFAULT");

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <StepTitle className="md:mt-sp-6">
            {t("FUNNEL_CONTACT_INFO_TITLE")}
          </StepTitle>
          <StepSubtitle className="mb-sp-8 mt-sp-1 max-w-screen-sm">
            {contentSubtitle}
          </StepSubtitle>
          <ContactInfoInputs />
        </StepContent>
        <ActionsContainer>
          <PrivacyDisclaimer />
          <ActionButton>
            {t("FUNNEL_CONTACT_INFO_ACTION_BUTTON_RESCHEDULE")}
          </ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
